import { TranslateService } from '@ngx-translate/core';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { DataProvider } from 'projects/packcert-web/src/app/providers/data.provider';
import { Message, SpinnerService, UtilsService } from 'shared-components';
import { AdminContextService } from '../../context/admin-contex.service';
import { AdminService } from '../../services/admin.service';
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { SessionContextService } from 'projects/packcert-web/src/app/context/session-context.service';

@Component({
    selector: 'app-mantenimiento-entidades-control',
    templateUrl: './mantenimiento-entidades-control.component.html'
})
export class MantenimientoEntidadesControlComponent implements OnInit, OnDestroy {

    private readonly _DEFAULT_ITEMS_PER_PAGE = 10;

    private _filters;
    public filtersVisible = false;
    public filtersForm: UntypedFormGroup;

    public toCloseSpinner = 0;

    public entidadesControl;
    public denominaciones;
    public auditores;
    public integradores;

    public paisId;
    public denominacionId;
    public entidadControl;

    public newEditModal = false;
    public deleteModal = false;

    public mensajes = new Array<Message>();
    public showError: boolean;

    public disabledDenominaciones: Subject<boolean> = new Subject();
    public disabledAuditores: Subject<boolean> = new Subject();
    public disabledIntegradores: Subject<boolean> = new Subject();

    public dropdownSection: number;
    public pestanaActiva = new Array<number>();

    public itemsPerPage = this._DEFAULT_ITEMS_PER_PAGE;
    public currentPage = 0;
    public totalItems: number;
    public readonly visiblePages = 3;

    public orderBy: string;
    public columnId: number;

    private readonly destroy$ = new Subject<void>();

    constructor(
        private _fb: UntypedFormBuilder,
        private readonly _spinnerService: SpinnerService,
        private readonly _sessionContext: SessionContextService,
        private readonly _dataProvider: DataProvider,
        private readonly _adminContext: AdminContextService,
        private readonly _adminService: AdminService,
        private readonly utilsService: UtilsService,
        private readonly _translate: TranslateService
    ) { }

    ngOnInit() {
        this.filtersForm = this._fb.group({
            pais: [''],
            denominacion: [{ value: '', disabled: true }],
            des: [''],
            auditor: [{ value: '', disabled: true }],
            integrador: [{ value: '', disabled: true }],
            fechaInicio: [''],
            fechaFin: [''],
            dateType: ['false']
        });

        this._adminContext.mantenimientoEntidadesControlFilters = null;

        this.filtersForm.get('fechaInicio').valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => this.validDates());
        this.filtersForm.get('fechaFin').valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => this.validDates());

        this.filtersForm.get('pais').valueChanges.pipe(takeUntil(this.destroy$)).subscribe((pais) => {
            if (pais) {
                this.getDenominacionesByPais(pais.id);
            } else {
                this.disabledDenominaciones.next(true);
                this.denominaciones = [];
                this.filtersForm.get('denominacion').patchValue('');
                this.filtersForm.get('denominacion').disable();
            }
        });

        this.filtersForm.get('denominacion').valueChanges.pipe(takeUntil(this.destroy$)).subscribe((denominacion) => {
            if (denominacion) {
                this.getAuditoresByDenominacion(denominacion.id);
                this.getIntegradoresByDenominacion(denominacion.id);
            } else {
                this.disabledAuditores.next(true);
                this.disabledIntegradores.next(true);
                this.auditores = [];
                this.integradores = [];
                this.filtersForm.get('auditor').patchValue('');
                this.filtersForm.get('auditor').disable();
                this.filtersForm.get('integrador').patchValue('');
                this.filtersForm.get('integrador').disable();
            }
        });

        this.getEntidadesControl();
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    public get paises() {
        if (this._dataProvider.paises) {
            if (this._dataProvider.paises.length === 1 && this.filtersForm.get('pais').enabled) {
              this.filtersForm.get('pais').patchValue(this._dataProvider.paises[0]);
              this.filtersForm.get('pais').disable();
            }
          }
        return this._dataProvider.paises;
    }

    public get defaultLanguage() {
      return this._translate.getDefaultLang();
    }

    public get isSmallScreen(){
      return this._sessionContext.isSmallScreen();
    }

    public getDenominacionesByPais(paisId) {
        let filters = {
            paisId: paisId
        };
        this._spinnerService.showSpinner();
        this.toCloseSpinner += 1;
        this._adminService.getDenominaciones(filters).toPromise().finally(() => {
            this.checkCloseSpinner();
        }).then((resp) => {
            if (resp.lista.length > 0) {
                this.denominaciones = resp.lista;
                this.filtersForm.get('denominacion').enable();
                this.disabledDenominaciones.next(false);
            }
        });
    }

    public getAuditoresByDenominacion(denominacionId) {
        let filters = {
            denominacionIdAcceso: denominacionId
        };
        this._spinnerService.showSpinner();
        this.toCloseSpinner += 1;
        this._adminService.getAuditores(filters).toPromise().finally(() => {
            this.checkCloseSpinner();
        }).then((resp) => {
            if (resp.lista.length > 0) {
                this.auditores = resp.lista;
                this.filtersForm.get('auditor').enable();
                this.disabledAuditores.next(false);
            }
        });
    }

    public getIntegradoresByDenominacion(denominacionId) {
        let filters = {
            denominacionIdAcceso: denominacionId
        };
        this._spinnerService.showSpinner();
        this.toCloseSpinner += 1;
        this._adminService.getIntegradores(filters).toPromise().finally(() => {
            this.checkCloseSpinner();
        }).then((resp) => {
            if (resp.lista.length > 0) {
                this.integradores = resp.lista;
                this.filtersForm.get('integrador').enable();
                this.disabledIntegradores.next(false);
            }
        });
    }

    public pageChange(page) {
        this.dropdownSection = -1;
        this._adminContext.mantenimientoEntidadesControlFilters.numPagina = this.currentPage = page -1;
        this.getEntidadesControl();
    }

    public itemsPerPageChange(items) {
        this.dropdownSection = -1;
        this._adminContext.mantenimientoEntidadesControlFilters.numPagina = this.currentPage = 0;
        this._adminContext.mantenimientoEntidadesControlFilters.tamPagina = this.itemsPerPage = items;
        this.getEntidadesControl();
    }

    private clearDatesValidators() {
        if (this.filtersForm.get('fechaFin').errors && this.filtersForm.get('fechaFin').value) {
            this.filtersForm.get('fechaFin').clearValidators();
            this.filtersForm.get('fechaFin').updateValueAndValidity();
        }
        if (this.filtersForm.get('fechaInicio').errors && this.filtersForm.get('fechaInicio').value) {
            this.filtersForm.get('fechaInicio').clearValidators();
            this.filtersForm.get('fechaInicio').updateValueAndValidity();
        }
    }

    public validDates() {
        if (this.filtersForm.get('fechaInicio').value && this.filtersForm.get('fechaFin').value) {
            if (this.checkDates(this.filtersForm.get('fechaInicio').value, this.filtersForm.get('fechaFin').value)) {
                this.clearDatesValidators();
            } else {
                this.filtersForm.get('fechaInicio').setErrors(['Invalid date']);
                this.filtersForm.get('fechaFin').setErrors(['Invalid date']);
            }
            if (this.filtersForm.get('fechaInicio').invalid || this.filtersForm.get('fechaFin').invalid) {
                this.showError = true;
                this.mensajes.push({ class: 'error', message: 'global.fecha.error.finAnteriorInicio'});
            } else {
                this.showError = false;
                this.mensajes = [];
            }
        } else {
            this.clearDatesValidators();
            this.showError = false;
            this.mensajes = [];
        }
    }

    private checkDates(inicio, fin) {
        const inicioD = new Date(inicio);
        const finD = new Date(fin);
        return inicioD <= finD;
    }

    public checkValuesForm(): boolean {
        return ((this.filtersForm.get('pais').value && this.filtersForm.get('pais').enabled) ||
            this.filtersForm.get('denominacion').value ||
            this.filtersForm.get('des').value ||
            this.filtersForm.get('auditor').value ||
            this.filtersForm.get('integrador').value ||
            this.filtersForm.get('fechaInicio').value ||
            this.filtersForm.get('fechaFin').value) ? true : false;
    }

    public resetForm() {
        this.filtersForm.reset({
            pais: this.filtersForm.get('pais').disabled ? this.filtersForm.get('pais').value : null
        });
        this.filtersForm.get('dateType').patchValue('false');
    }

    public filtrar() {
        this.validDates();
        
        if (this.filtersForm.valid) {
            this.applyFilters();
        }
    }

    private applyFilters() {
        this.currentPage = 0;
        this.dropdownSection = -1;
        this._adminContext.mantenimientoEntidadesControlFilters = {
            desEntidadControl: this.filtersForm.get('des').value ? this.filtersForm.get('des').value : '',
            paisIdAcceso: this.filtersForm.get('pais').value ? this.filtersForm.get('pais').value.id : null,
            denominacionIdAcceso: this.filtersForm.get('denominacion').value ? this.filtersForm.get('denominacion').value.id : null,
            auditorId: this.filtersForm.get('auditor').value ? this.filtersForm.get('auditor').value.id : null,
            integradorId: this.filtersForm.get('integrador').value ? this.filtersForm.get('integrador').value.id : null,
            cargaRegistroEnUso: true,
            fechaInicio: this.filtersForm.get('fechaInicio').value ?
                this.utilsService.parseGMTtoYYYYMMDD(this.filtersForm.get('fechaInicio').value) : '',
            fechaFin: this.filtersForm.get('fechaFin').value ?
                this.utilsService.parseGMTtoYYYYMMDD(this.filtersForm.get('fechaFin').value) : '',
            fechaActualizacion: this.filtersForm.get('dateType').value,
            numPagina: this.currentPage,
            tamPagina: this.itemsPerPage
        };
        this.getEntidadesControl();
    }

    public getEntidadesControl() {
        if (this._adminContext.mantenimientoEntidadesControlFilters) {
            this._filters = this._adminContext.mantenimientoEntidadesControlFilters;
        } else {
            this.applyFilters();
        }
        this._spinnerService.showSpinner();
        this._adminService.getEntidadesControl(this._filters).toPromise().finally(() => {
            this._spinnerService.hideSpinner();
        }).then((resp) => {
            this.totalItems = resp.paginacionMeta.totalCount;
            this.entidadesControl = resp.lista;
        }, (error) => {
            this.pushMessage('global.error.noResponse');
        });
    }

    public close() {
        this.deleteModal = false;
        this.newEditModal = false;
    }

    public create() {
        this.entidadControl = null;
        this.paisId = null;
        this.denominacionId = null;
        this.newEditModal = true;
    }

    public update(entidad) {
        window.event.stopPropagation();
        this.paisId = entidad.paisIdAcceso;
        this.denominacionId = entidad.denominacionIdAcceso;
        this.entidadControl = entidad;
        this.newEditModal = true;
    }

    public askDelete(entidad) {
        window.event.stopPropagation();
        this.entidadControl = entidad;
        this.deleteModal = true;
    }

    public delete() {
        this._spinnerService.showSpinner();
        this._adminService.deleteEntidadControl(this.entidadControl.id).toPromise().finally(() => {
            this._spinnerService.hideSpinner();
        }).then(() => {
            this.close();
            this._dataProvider.refreshEntidadControl();
            this.pushMessage('global.success.itemDeleted');
            this.getEntidadesControl();
        });
    }

    public pushMessage(mensaje) {
        this.showError = true;
        if (mensaje.includes('req') || mensaje.includes('exis') || mensaje.includes('ApiErrors') || mensaje.includes('no') || mensaje.includes('error')) {
            this.mensajes.push({ class: 'error', message: mensaje});
        } else {
            this.mensajes.push({ class: 'success', message: mensaje});
        }
    }

    public refresh(value) {
        this.newEditModal = false;
        this.deleteModal = false;
        if (value) {
            this.getEntidadesControl();
        }
    }

    public openTabs(i) {
        window.event.stopPropagation();
        this.dropdownSection = this.dropdownSection === i ? -1 : i;
        this.pestanaActiva[i] = this.pestanaActiva[i] > 0 ? this.pestanaActiva[i] : 1;
        // Desplazamiento a la izquierda para tablet (mismo tamaño máx. que en table.scss)
        if (this.dropdownSection !== -1 && window.innerWidth <= 1199) {
            // Retardo en caso de que haya otro detalle abierto
            setTimeout(() => {
                document.querySelector('table')?.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'start'});
            }, 50);
        }
    }

    public showPaisDenominacion(i) {
        this.pestanaActiva[i] = 1;
    }

    public showAuditores(i) {
        this.pestanaActiva[i] = 2;
    }

    public showRoyalties(i) {
      this.pestanaActiva[i] = 3;
    }

    public showBlockchain(i) {
        this.pestanaActiva[i] = 4;
    }

    private checkCloseSpinner() {
        this.toCloseSpinner -= 1;
        if (this.toCloseSpinner === 0) {
            this._spinnerService.hideSpinner();
        }
    }

    public getIcon(prop: string) {
      let iconClass = 'fa fa-sort';
      if (this._filters && this._filters.orderItems && this._filters.orderItems[0].orderProperty === prop) {
          iconClass = this._filters.orderItems[0].orderByDescending === true ? 'fa fa-sort-down' : 'fa fa-sort-up';
      }
      return iconClass;
    }

    public toOrderBy(columnFilter, idColumn) {
      this.columnId = idColumn;
      if (this.entidadesControl && this.entidadesControl.length > 0) {
        if (this._adminContext.mantenimientoEntidadesControlFilters) {
          this._filters = this._adminContext.mantenimientoEntidadesControlFilters;
          if (!this.orderBy || this.orderBy.includes('DESC')) {
            this.orderBy = 'ASC' + idColumn;
            this._filters.orderItems = [
              {
                orderProperty: columnFilter,
                orderByDescending: false
              }
            ];
          } else if (this.orderBy.includes('ASC')) {
            this.orderBy = 'DESC' + idColumn;
            this._filters.orderItems = [
              {
                orderProperty: columnFilter,
                orderByDescending: true
              }
            ];
          }
          this.getEntidadesControl();
        }
      }
    }

    public trackByEntidadId(index: number, entidad: { id: number }): number {
      return entidad.id;
    }
}
